import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GrundstueckRubrikComponentVM } from '../grundstueck-rubrik-component-v-m';
import { GbgrundstueckService } from '../../../core/gb-api';
import { GrundstueckRubrikService } from '../grundstueck-rubrik.service';
import { AppConfigService } from '../../../core/services/app-config.service';
import { TimepointService } from '../../../core/services/timepoint.service';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { RubrikConfigEntry } from '../../../core/base-api';
import { GrundstueckRubrikenComponent } from '../grundstueck-rubriken.component';

@Component({
  selector: 'cap-grundstueck-alle-rubrik',
  templateUrl: './grundstueck-gb-av-rubrik.component.html',
  styleUrls: ['./grundstueck-gb-av-rubrik.component.scss'],
  imports: [GrundstueckRubrikenComponent]
})
export class GrundstueckGbAvRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  rubriken: Array<GrundstueckRubrikComponentVM>;

  constructor(
    private rubrikenService: GrundstueckRubrikService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected loadData() {
    this.addSub(
      this.rubrikenService.getRubriken(RubrikConfigEntry.RubrikEnum.GB_DETAIL_GRUNDSTUECK).subscribe((rubriken) => {
        this.rubriken = rubriken;
      })
    );
  }
}
